/* ═══════════════════════════════════════════════════════════════════════════
 * LES ÉNONCÉS DE RÉFÉRENTIEL VIDE — ÉCRITS UNE FOIS
 * ═══════════════════════════════════════════════════════════════════════════
 * ⚠️ POURQUOI CE FICHIER EXISTE. La même situation — « ce tenant n'a pas encore
 *    de postes » — était énoncée à DEUX endroits, dans DEUX formulations :
 *      · PersonnelAdminPage : rien du tout, un select muet ;
 *      · AgentsRHPage      : « Aucun poste au référentiel. Les créer dans
 *                             "Gestion des postes". »
 *    Deux énoncés pour une notion divergent toujours — et le jour où l'on
 *    corrige l'un, l'autre survit. C'est exactement ce qui vient de se produire
 *    sur la vitrine avec « 2 mois offerts », qui a traversé trois lots.
 *    ➡️ Un seul texte, importé par les deux écrans.
 *
 * ⚠️ IL NE PARLE PAS DU LECTEUR (décision de Dom, 14/09/2026). Il ne dit pas
 *    « votre profil n'autorise pas », il ne se ramifie pas selon le rôle : il
 *    dit QUI FAIT CE TRAVAIL. La règle 26 tient — le produit n'explique pas
 *    ses restrictions à l'écran, et un refus expliqué est un inventaire des
 *    portes fermées remis à celui qui n'a pas la clé.
 *
 * ⚠️ LE CHEMIN EST DU TEXTE, PAS UN LIEN. Créer un poste est réservé à
 *    `admin`, `dg`, `rh` (`postesRoutes.js`, canWrite) ; `assistante_direction`
 *    voit ce message et n'a pas le droit. Un lien l'enverrait cliquer vers un
 *    refus — on ne propose pas une porte qu'on va fermer.
 *
 * ⚠️ AUCUNE LISTE PAR DÉFAUT N'EST POSÉE PAR L'ÉDITEUR. Le vide est de la
 *    DONNÉE : un tenant décide de ses postes. Ce qui manquait n'était pas une
 *    semence, c'était un énoncé (file n° 23).
 * ═══════════════════════════════════════════════════════════════════════════ */
import { t } from 'i18n';

/** Aucun poste au référentiel du tenant. Texte de Dom, mot pour mot. */
export const AUCUN_POSTE = t(
  'Aucun poste n’est défini. Les postes sont créés par les RH ou un administrateur, '
  + 'dans Ressources humaines → Gestion des postes.'
);
